import React from 'react';
// import CircularProgress from '@mui/material/CircularProgress';
import { Backdrop, LinearProgress, Box } from '@mui/material';

const PageLoader = () => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            {/* <CircularProgress color="secondary" /> */}
            <Box sx={{ width: '75%' }}>
                <LinearProgress color="primary" />
            </Box>
        </Backdrop>
    );
};

export default PageLoader;
